<template>
    <NuxtLayout>
        <Head>
            <Title>{{ pageData.title }}</Title>
            <Meta name="description" :content="pageData.meta_description" />
            <Meta name="keywords" :content="pageData.meta_keywords" />
            <Meta name="title" :content="pageData.meta_title" />
        </Head>
        <div class="body-block" v-html="pageData.description"></div>
    </NuxtLayout>
</template>
<script setup lang="ts">
import api from '~/api/api';
import { avalibeRouter } from '~/stores/avalibeRouter';

definePageMeta({
    middleware: 'available',
});
const route = useRoute();

const nuxtApp = useNuxtApp();
const pageData = ref({
    id: -1,
    url: '',
    title: '',
    description: '',
    meta_title: '',
    meta_description: '',
    meta_keywords: '',
});

const routeStore = avalibeRouter();
const paramPage = route.params.page as string;
const id = routeStore.getIdByUrl(paramPage);
const { data: pageInfo } = await useAsyncData(() => api.getPagesData(nuxtApp.$i18n.locale.value, id), {
    watch: nuxtApp.$i18n.locale,
});
watch(
    pageInfo,
    async () => {
        pageInfo.value.meta_title = pageInfo.value.meta_title !== undefined && pageInfo.value.meta_title.length ? pageInfo.value.meta_title : pageInfo.value.tilte;
        pageData.value = pageInfo.value;
    },
    {
        immediate: true,
    }
);
</script>

<style scoped>
</style>
